<div
  style="background: #f2f7f7"
  class="text-gray-500 pb-2.5 pt-2.5 min-h-[50px] short:min-h-[40px] short:py-1">
  <div
    class="grid items-center w-full"
    style="grid-template-columns: 1fr auto 1fr">
    <div class="flex items-center">
      <button
        *ngIf="buttonBack"
        class="flex items-center text-softGray"
        (click)="actionBack()">
        <svg
          class="size-icon-sm font-extrabold"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M15 19l-7-7 7-7" />
        </svg>
        <span class="text-softGray text-fluid-xl uppercase">
          {{ 'BACK' | translate }}
        </span>
      </button>

      <div *ngIf="subtitle" class="flex flex-col items-start">
        <span class="font-bold uppercase text-[#2F5973] text-fluid-xl">
          {{ name }}
        </span>
        <span class="uppercase mt-1 text-[#2f5975b3] text-fluid-lg">
          <span *ngIf="distribuidora">{{ distribuidora }}</span>
          <span class="text-[#2F5975] font-medium"> • {{ screen }} </span>
        </span>
      </div>
    </div>
    <div *ngIf="title" class="flex items-end justify-center">
      <span
        class="text-fluid-header short:text-fluid-title font-normal uppercase pb-1 text-[#2F5973] text-center leading-tight">
        {{ title }}
      </span>
    </div>
    <div *ngIf="!title"></div>
    <div></div>
  </div>
</div>

<div
  class="border-t-2 opacity-[0.4] border-[#2F5E73] pb-2 short:pb-1 -mx-4"
  [ngClass]="{ 'no-padding': paddingRow }"></div>
